<section class="bg-blue-50 py-24 dark:bg-[#15202b]">
  <div class="mx-auto max-w-4xl px-6 lg:px-8">
    <div class="overflow-hidden rounded-2xl rounded-tr-[50px] bg-white shadow-xl dark:bg-shl-navy">
      <div class="bg-shl-navy p-10 text-center text-white">
        <h2 class="text-3xl font-black">{{ 'quote_form.title' | translate }}</h2>
        <p class="mt-2 text-blue-200">{{ 'quote_form.subtitle' | translate }}</p>
      </div>
      <form class="p-8 md:p-12" [formGroup]="form" (ngSubmit)="submit()">
        <div class="grid gap-6 md:grid-cols-2">
          <div class="space-y-2">
            <label class="text-sm font-semibold text-shl-navy dark:text-white" for="quote-full-name">
              {{ 'quote_form.full_name_label' | translate }}
            </label>
            <input
              class="w-full rounded-lg rounded-tr-[20px] border-gray-200 bg-gray-50 p-3 focus:border-shl-sky focus:ring-shl-sky dark:bg-gray-800 dark:border-gray-700 dark:text-white"
              id="quote-full-name"
              [placeholder]="'quote_form.full_name_placeholder' | translate"
              type="text"
              formControlName="fullName"
            />
          </div>
          <div class="space-y-2">
            <label class="text-sm font-semibold text-shl-navy dark:text-white" for="quote-email">
              {{ 'quote_form.email_label' | translate }}
            </label>
            <input
              class="w-full rounded-lg rounded-tr-[20px] border-gray-200 bg-gray-50 p-3 focus:border-shl-sky focus:ring-shl-sky dark:bg-gray-800 dark:border-gray-700 dark:text-white"
              id="quote-email"
              [placeholder]="'quote_form.email_placeholder' | translate"
              type="email"
              formControlName="email"
            />
          </div>
          <div class="space-y-2">
            <label class="text-sm font-semibold text-shl-navy dark:text-white" for="quote-phone">
              {{ 'quote_form.phone_label' | translate }}
            </label>
            <input
              class="w-full rounded-lg rounded-tr-[20px] border-gray-200 bg-gray-50 p-3 focus:border-shl-sky focus:ring-shl-sky dark:bg-gray-800 dark:border-gray-700 dark:text-white"
              id="quote-phone"
              [placeholder]="'quote_form.phone_placeholder' | translate"
              type="tel"
              formControlName="phone"
            />
          </div>
          <div class="space-y-2">
            <label class="text-sm font-semibold text-shl-navy dark:text-white" for="quote-company">
              {{ 'quote_form.company_label' | translate }}
            </label>
            <input
              class="w-full rounded-lg rounded-tr-[20px] border-gray-200 bg-gray-50 p-3 focus:border-shl-sky focus:ring-shl-sky dark:bg-gray-800 dark:border-gray-700 dark:text-white"
              id="quote-company"
              [placeholder]="'quote_form.company_placeholder' | translate"
              type="text"
              formControlName="company"
            />
          </div>
          <div class="space-y-2">
            <label class="text-sm font-semibold text-shl-navy dark:text-white" for="quote-cargo-type">
              {{ 'quote_form.cargo_type_label' | translate }}
            </label>
            <select
              class="w-full rounded-lg rounded-tr-[20px] border-gray-200 bg-gray-50 p-3 focus:border-shl-sky focus:ring-shl-sky dark:bg-gray-800 dark:border-gray-700 dark:text-white"
              id="quote-cargo-type"
              formControlName="cargoType"
            >
              <option value="">{{ 'quote_form.cargo_type_placeholder' | translate }}</option>
              <option>{{ 'quote_form.cargo_type_general_merchandise' | translate }}</option>
              <option>{{ 'quote_form.cargo_type_perishable_goods' | translate }}</option>
              <option>{{ 'quote_form.cargo_type_hazardous_material' | translate }}</option>
            </select>
          </div>
          <div class="space-y-2">
            <label class="text-sm font-semibold text-shl-navy dark:text-white" for="quote-weight">
              {{ 'quote_form.weight_label' | translate }}
            </label>
            <input
              class="w-full rounded-lg rounded-tr-[20px] border-gray-200 bg-gray-50 p-3 focus:border-shl-sky focus:ring-shl-sky dark:bg-gray-800 dark:border-gray-700 dark:text-white"
              id="quote-weight"
              [placeholder]="'quote_form.weight_placeholder' | translate"
              type="number"
              formControlName="weight"
            />
          </div>
        </div>
        <div class="mt-6 space-y-2">
          <label class="text-sm font-semibold text-shl-navy dark:text-white" for="quote-details">
            {{ 'quote_form.details_label' | translate }}
          </label>
          <textarea
            class="w-full rounded-lg rounded-tr-[20px] border-gray-200 bg-gray-50 p-3 focus:border-shl-sky focus:ring-shl-sky dark:bg-gray-800 dark:border-gray-700 dark:text-white"
            id="quote-details"
            [placeholder]="'quote_form.details_placeholder' | translate"
            rows="4"
            formControlName="details"
          ></textarea>
        </div>
        <button
          class="mt-8 w-full rounded-lg rounded-se-[30px] bg-shl-navy py-4 text-base font-bold text-white shadow-lg transition-transform hover:scale-[1.01] hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-shl-sky focus:ring-offset-2"
          type="submit"
        >
          {{ 'quote_form.submit' | translate }}
        </button>
      </form>
    </div>
  </div>
</section>
